import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { TopBarComponent } from '../top-bar/top-bar.component';

@Component({
  imports: [RouterOutlet, TopBarComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'agrarsense-web';
}
